import { CocoFooter } from '@cocolocala/ui-components';
import { CocoLogoNavigationBar } from '@cocolocala/ui-components';
import { NextPage } from 'next';
import { NextSeo } from 'next-seo';
import React from 'react';

import { useSignUpPage } from '~/feature/sign-up/hooks/mobile';
import PageContainer from '~/shared/components/mobile/PageContainer';
import SignContainer from '~/shared/components/Sign/SignContainer';
import { SIGN_TYPES } from '~/shared/components/Sign/types';
import { GetConfigUtil } from '~/shared/utils/envUtil';

const SignUpPage: NextPage = () => {
  const imgixHost = GetConfigUtil.getPublicStaticConfig().IMGIX_HOST;
  const host = GetConfigUtil.getPublicStaticConfig().HOST;
  const {
    onClickTab,
    onSubmitSignIn,
    onSubmitSignUp,
    isSubmitting,
  } = useSignUpPage();

  return (
    <>
      <NextSeo title={`無料会員登録`} noindex={true} />
      <PageContainer>
        <CocoLogoNavigationBar
          hideDrawer={true}
          hostUrl={GetConfigUtil.getPublicStaticConfig().HOST}
        />
        <SignContainer
          signType={SIGN_TYPES.SIGN_UP}
          onSubmitSignUp={onSubmitSignUp}
          onSubmitSignIn={onSubmitSignIn}
          isSubmitting={isSubmitting}
          onClickTab={onClickTab}
        />
        <CocoFooter imgixHost={imgixHost} hasLinks={true} hostUrl={host} />
      </PageContainer>
    </>
  );
};

export default SignUpPage;
